<template>
  <el-upload
    ref="upload"
    action="#"
    :limit="limit"
    :file-list="fileList"
    :before-upload="beforeUpload"
    :http-request="handleUpdate"
    :on-remove="handleUpdate"
    :on-exceed="onExceed"
    v-bind="$attrs"
  >
    <el-button size="small" type="primary">点击上传</el-button>
    <div slot="tip" class="el-upload__tip">
      <slot name="tip"></slot>
    </div>
  </el-upload>
</template>

<script>
import _ from "lodash";

export default {
  name: "matrix-upload-no-action",
  props: {
    limit: [Number],
    maxSize: { // 限制文件大小 (M)
      type: [Number, String],
      default: 5,
    }
  },
  data() {
    return {
      fileList: [],
      handleUpdate: _.debounce(this.updateResult, 300),
    }
  },
  methods: {
    beforeUpload(file) {
      if (file.size > this.maxSize * 1024 * 1024) {
        this.$message.error('导入文件不能超过5M')
        return false
      }
    },
    updateResult() {
     this.$emit('update:files', this.$refs.upload.uploadFiles)
    },
    onExceed() {
      this.$message.error(`最多上传${this.limit}个文件`)
    }
  }
}
</script>

<style scoped lang="scss">

</style>
